<p class="lead m-t-xl">{{ authContent.instructionHeader }}</p>
<div class="row" *ngFor="let item of authContent.items">
  <div class="col-12 m-t-lg">
    <p class="lead bold">{{ item.step }}</p>
    <div [innerHtml]="item.description"></div>
  </div>
</div>
